import React from "react";

const ViewLead = ({ leadDetails }) => {
  console.log("leadDetails...", JSON.stringify(leadDetails, null, 2));
  return <div>ViewLead</div>;
};

export default ViewLead;
